// extracted by mini-css-extract-plugin
module.exports = {"root":"ShareLink__root--13xzh","icon":"ShareLink__icon--2ToYo"};